import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { connect } from 'react-redux';
import { withLocalize } from 'react-localize-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';
import { Field, connect as connectFormik, ErrorMessage } from 'formik';
import { domainActions } from '../../store/domainStore';
import { selectDefaultStyles } from './selectDefaultStyles';
import { getNested, toName, isNullOrUndefined, validateInput } from '../../store/storeFunctions';
import { registerHook, isClickTo, unregisterHook } from '../../store/clickWrapper';
import BbRadioWrapper from './BbRadioWrapper';
import BbColumnedField from './bbColumnedField';

import './bbInput.scss';

class BbInput extends React.Component {
    placeholder = {
        //static = normal label element above field
        static: this.props.placeholder !== undefined && this.props.placeholder.type === 'static',
        //inline = placeholder prop on input element
        inline: this.props.placeholder !== undefined && this.props.placeholder.type === 'inline',
        //jumping = label element above field placed into placeholder position moved away when input is focused or contains text
        jumping: this.props.placeholder !== undefined && this.props.placeholder.type === 'jumping',
        //column = input is divided into two columns - one column for label and another for input itself
        column: this.props.placeholder !== undefined && this.props.placeholder.type === 'column'
    };

    static defaultProps = {
        showError: true,
        filterByValuePrefix: false
    };

    componentDidMount() {
        if (this.props.type === 'async-select' && this.props.domain !== undefined) {
            this.props.ensureDomainData(this.props.domain);
        }
    }

    renderIcon = (position) => {
        if (this.props.icon === undefined || this.props.icon[position] === undefined) {
            return null;
        }
        const iconVar = this.props.icon[position];
        if (typeof iconVar === 'string' || iconVar instanceof String) {
            return (
                <span className={'icon is-small ' + `is-${position}`}>
                    <FontAwesomeIcon icon={this.props.icon[position]} />
                </span>
            );
        }
        return iconVar;
    }

    renderError = () => {
        if (this.hasError())
            return <p className="help is-danger">{ReactHtmlParser(this.props.error.errors[this.props.name])}</p>;
        return null;
    }

    hasError = () => {
        const hasError = this.props.error !== undefined && this.props.error.errors !== undefined && this.props.error.errors[this.props.name] !== undefined && this.props.error.errors[this.props.name] !== '';
        const isTouched = this.props.error !== undefined && this.props.error.touched !== undefined && this.props.error.touched[this.props.name] === true;

        return !(!hasError || (hasError && !isTouched));
    }

    renderByType = (innerType) => {
        let disabled = this.props.disabled !== undefined && this.props.disabled;
        const fieldCore = (() => {
            switch (innerType) {
                case 'async-select':
                    return (<Field autoComplete={this.props.autoComplete} component={CustomAsyncSelect} disabled={disabled} {...this.props} />);
                case 'popup-select':
                    return (<Field autoComplete={this.props.autoComplete} component={CustomPopupSelect} disabled={disabled} {...this.props} />);
                case 'select':
                    return (<Field autoComplete={this.props.autoComplete} component={CustomSelect} disabled={disabled} {...this.props} />);
                case 'select-noformik':
                    return (<CustomSelect {...this.props} />);
                case 'custom':
                    return this.props.custom;
                case 'radio':
                    return (<>
                        {this.props.options.map((i, j) => {
                            let idVal = `$radio-${i.value}`;
                            if (this.props.idFormat !== null && this.props.idFormat !== undefined) {
                                idVal = this.props.idFormat(i.value) || idVal;
                            }
                            return (<div className="control" key={idVal} style={{ display: "flex" }}>
                                <BbRadioWrapper id={idVal} name={idVal}
                                    value={i.value} checked={this.props.checkedValue === i.value}
                                    callback={(e) => this.props.callback(e.target.value)}
                                    label={i.customLabel || this.props.translate(i.label)}
                                    disabled={disabled}
                                    useDefaultColorOnDisabled={this.props.useDefaultColorOnDisabled}
                                />
                            </div>)
                        })}
                    </>);
                default:
                    return <React.Fragment>
                        <Field id={this.props.id} innerRef={this.props.innerRef} autoComplete={this.props.autoComplete} type={this.props.type} name={this.props.name}
                            placeholder={this.placeholder.inline ? this.props.label : undefined} disabled={disabled} min={this.props.min} max={this.props.max}
                            className={classnames({
                                'bb-input-expanded': disabled, 'input': true, 'form-control': true,
                                'is-invalid': getNested(this.props.errors, this.props.name) && getNested(this.props.touched, this.props.name)
                            })} onInput={(e) => validateInput(e, this.props.onInput)} />
                        {this.props.showError && <ErrorMessage name={this.props.name} component="div" className="invalid-feedback" />}
                    </React.Fragment>
            }
        })();

        return this.placeholder.column ? <BbColumnedField label={this.props.label} field={fieldCore} innerType={innerType} thinInput={this.props.thinInput} noWidthOverride={this.props.noWidthOverride} useDefaultColorOnDisabled={this.props.useDefaultColorOnDisabled}
        /> : fieldCore;
    }

    onAsyncChange = (evnt) => {
    }

    render() {
        return (
            <div className={classnames({ 'inactive-input-font-color': this.props.disabled, 'field bb-field': true })} style={this.props.style}>
                {!this.placeholder.inline && !this.placeholder.column &&
                    <label className={classnames({ 'jumping': this.placeholder.jumping, 'active-input-font-color': this.props.disabled })}>{this.props.label}</label>
                }
                <div className={classnames({ 'active-input-font-color': this.props.disabled, 'control': true, 'has-icons-left': this.props.icon !== undefined && this.props.icon.left !== undefined, 'has-icons-right': this.props.icon !== undefined && this.props.icon.right !== undefined })}
                    data-error={this.hasError() ? "true" : "false"} title={this.props.title || undefined}>
                    {this.renderByType(this.props.type)}
                    {this.renderIcon('left')}
                    {this.renderIcon('right')}
                    {this.renderError()}
                </div>
            </div>
        );
    }
}
BbInput.propTypes = {
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    name: PropTypes.string
};

class CustomAsyncSelect extends React.Component {
    state = {
        focused: false, currentVal: '', inputWidth: 2, isLoading: false,
        candidates: [], maxItems: 15, selected: this.props.field.value || [], initialized: false
    };

    controlElement = undefined;
    inputElement = undefined;
    options = undefined;

    componentDidMount() {
        this.hookId = registerHook(this, (click) => {
            if (!isClickTo(click, [this.controlElement, this.options])) {
                this.focus(false);
            }
        });
        this.setState({ isLoading: this.isLoading() })
    }

    componentWillUnmount() {
        unregisterHook(this.hookId);
    }

    componentDidUpdate(prevProps) {
        if (this.props.type === 'async-select' && this.props.domain !== undefined && this.props.domain !== prevProps.domain) {
            this.props.ensureDomainData(this.props.domain);
        }
        if (this.props[this.props.domain].isRequesting !== prevProps[prevProps.domain].isRequesting)
            this.setState({ isLoading: this.isLoading() });
        if (this.props.field.value !== prevProps.field.value)
            this.setState({ selected: this.props.field.value });
    }

    isLoading() {
        return this.props[this.props.domain].isRequesting || this.props[this.props.domain].requestResult === null;
    }

    focus = (val) => {
        if (val === this.state.focused && this.state.currentVal === '' && this.state.candidates.length === 0) { return; }

        let newState = { focused: val };
        if (document.activeElement !== this.inputElement && document.activeElement !== this.controlElement) {
            newState['currentVal'] = '';
            newState['candidates'] = [];
        }
        this.setState(newState);
    }

    inputChanged = (e) => {
        const v = e[toName([116, 97, 114, 103, 101, 116])][toName([118, 97, 108, 117, 101])];
        this.setState({ inputWidth: this.inputElement.scrollWidth + 5, currentVal: v });

        if (v.length > 2) {
            const prefix = this.props.filterByValuePrefix === true && this.state.selected.length > 0 ? this.getFirstValuePrefix() : null;
            this.setState({ isLoading: true });
            const searchValue = v.toLowerCase();
            if (this.props[this.props.domain].isRequesting || this.props[this.props.domain].requestResult === undefined) { return; }
            setTimeout(function () {
                let candidates = this.props[this.props.domain].requestResult;

                candidates.sort((a, b) => {
                    if (a.label.toLowerCase().startsWith(searchValue) && !b.label.toLowerCase().startsWith(searchValue)) {
                      return -1;
                    } else if (!a.label.toLowerCase().startsWith(searchValue) && b.label.toLowerCase().startsWith(searchValue)) {
                      return 1;
                    } else {
                      if (a.label.toLowerCase().indexOf(searchValue) < b.label.toLowerCase().indexOf(searchValue)) {
                        return -1;
                      } else {
                        return 1;
                      }
                    }
                  });
                  
                if (!isNullOrUndefined(prefix))
                    candidates = candidates.filter(f => f.value.startsWith(prefix));
                candidates = candidates
                    .filter(x => x.label.toLowerCase().includes(searchValue) || x.normalized.includes(searchValue))
                    .filter(x => this.state.selected.filter(s => s.normalized === x.normalized).length === 0)
                    .filter((x, i) => i < this.state.maxItems);
                if (candidates.length < this.state.maxItems) {
                    candidates.concat(this.props[this.props.domain].requestResult
                        .filter(x => x.label.toLowerCase().includes(searchValue) || x.normalized.includes(searchValue))
                        .filter(x => this.state.selected.filter(s => s.normalized === x.normalized).length === 0)
                        .filter((x, i) => i < this.state.maxItems - candidates.length))
                }

               

                this.setState({ candidates, isLoading: false });
            }.bind(this), 0);
        } else {
            this.setState({ candidates: [] })
        }
    }

    focusOnInput = () => {
        if (document.activeElement !== this.inputElement) {
            this.inputElement.focus();
        }
    }

    addValue = (val) => {
        let newselected = [...this.state.selected];
        newselected.push(val);
        this.setState({ selected: newselected, currentVal: '', candidates: [] });
        this.props.form.setFieldValue(this.props.field.name, newselected, false);
    }

    removeValue = (val) => {
        const newselected = this.state.selected.filter(x => x.normalized !== val.normalized);
        this.setState({ selected: newselected });
        this.props.form.setFieldValue(this.props.field.name, newselected, false);
    }

    render() {
        return (
            <React.Fragment>
                {this.state.isLoading && this.renderLoading()}
                <div className={classnames({
                    'async-select-container': true,
                    'has-data': !isNullOrUndefined(this.state.currentVal) && this.state.currentVal.length > 0 ||
                        this.state.focused || !isNullOrUndefined(this.state.selected) && this.state.selected.length > 0
                })}>
                    <div className='control'>
                        <div className={classnames("select-controls input", { "has-focus": this.state.focused })}
                            ref={el => this.controlElement = el} onClick={this.focusOnInput} style={{ height: 'auto' }}
                        >
                            {!isNullOrUndefined(this.state.selected) && this.state.selected.length > 0 && this.renderSelected()}
                            <input type="text" ref={(el) => this.inputElement = el}
                                autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false"
                                name={(this.props || {}).name}
                                disabled={(this.props || {}).disabled}
                                style={{ width: this.state.inputWidth, minHeight: '2em', display: (this.props || {}).disabled ? 'none' : null }}
                                value={this.state.currentVal}
                                onFocus={() => this.focus(true)}
                                onChange={e => this.inputChanged(e)} />
                        </div>
                        {this.state.currentVal.length > 2 && this.state.candidates.length === 0 && this.renderNoMatch()}
                        {this.state.currentVal.length > 0 && this.renderCandidates()}
                    </div>
                </div>
            </React.Fragment>
        );
    }

    renderNoMatch = () => {
        if (this.props.noMatchFound === null || this.props.noMatchFound === undefined || this.props.noMatchFound === '') {
            return '';
        }
        return (
            <div className="async-select-hints" style={{ pointerEvents: 'none' }}>
                <div style={{ padding: '1em' }}><i>{this.props.noMatchFound}</i></div>
            </div>
        );
    }

    renderCandidates = () => {
        const hasHint = this.props.hintText !== null && this.props.hintText !== undefined && this.props.hintText !== '';
        return (
            <div className="async-select-options" ref={(el) => this.options = el}>
                <PerfectScrollbar>
                    <ul>
                        {hasHint && <li className="async-select-hints">
                            <div style={{ pointerEvents: 'none' }}>
                                {ReactHtmlParser(this.props.hintText)}
                            </div>
                        </li>}
                        {this.state.candidates.length > 0 && this.state.candidates.map((c, i) => <li
                            key={`${i}${c.normalized}`} onClick={() => this.addValue(c)}
                        >
                            {ReactHtmlParser(this.highlightTerm(c.label, this.state.currentVal))}
                        </li>)}
                    </ul>
                </PerfectScrollbar>
            </div>
        );
    }

    highlightTerm = (value, term) => {
        value = value.replace(new RegExp("(?![^&;]+;)(?!<[^<>]*)(" + term + ")(?![^<>]*>)(?![^&;]+;)", "gi"), "<b>$1</b>");
        var type = value.match(/(\(.*\))/g);
        return (isNullOrUndefined(type) || type.length === 0) ? value : value.replace(/(\(.*\))/g, "<span class=\"type-hints\">" + type[0] + "</span>");
    }

    renderSelected = () => {
        return this.state.selected.map(s => (
            <div key={s.normalized} className="selected-item">
                <div className="select-item-label" style={{whiteSpace:"normal"}}>{s.label}</div>
                <div className="select-item-remove" onClick={() => this.removeValue(s)} ><svg height="14" width="14" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path></svg></div>
            </div>
        ))
    }

    renderLoading = () => {
        return <div className="search-progress searching" style={{ height: 2 }}></div>;
    }

    getFirstValuePrefix() {
        const match = this.state.selected[0].value.match(/.*?_/);
        return isNullOrUndefined(match) ? null : match[0];
    }
};

class CustomSelect extends React.Component {
    render() {
        return (
            <Select isMulti={false} closeMenuOnSelect={true} formatOptionLabel={this.props.formatOptionLabel}
                options={this.props.options}
                styles={this.props.styles || selectDefaultStyles}
                placeholder={this.props.selectPlaceholder || null}
                onChange={this.props.onChange}
                defaultValue={this.props.defaultValue}
                classNamePrefix={this.props.classNamePrefix || "select"}
                isSearchable={this.props.isSearchable}
                isDisabled={this.props.isDisabled}
                value={this.props.value}
                menuPosition={this.props.isFixed ? 'fixed' : 'absolute'}
                menuPortalTarget={this.props.isFixed ? document.body : null}
                noOptionsMessage={() => this.props.noOptionsMessage || this.props.translate('Search.NoData')}
                filterOption={this.props.filterOption}
            />
        );
    }
};

class CustomPopupSelect extends React.Component {

}

export const BbSelectNoFormik = withLocalize(connect(
    state => ({ ...state.domain, user: state.userContext }),
    dispatch => bindActionCreators(domainActions, dispatch)
)(CustomSelect));

export default withLocalize(connectFormik(connect(
    state => ({ ...state.domain, user: state.userContext }),
    dispatch => bindActionCreators(domainActions, dispatch)
)(BbInput)));